import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\HASEE\\Documents\\ChatGPT\\生产项目\\cf-migrations\\nextwork\\build\\linz-open\\node_modules\\next-intl\\dist\\esm\\production\\navigation\\shared\\BaseLink.js");
